import {useGetTeamProgressChart} from "@/app2/shared/data";
import {useTeamProgressContext} from "../context/TeamProgressContext";
import {useEffect} from "react";

/**
 * Feature hook for Team Progress chart
 * 
 * Fetches lessons completed over time and manages section loading state.
 */
export function useChart() {
	const {filters, updateSectionState} = useTeamProgressContext();

	const {data, isLoading, isError, error} = useGetTeamProgressChart({
		dateFrom: filters.dateFrom,
		dateTo: filters.dateTo,
		archivedUsers: filters.archivedUsers
	});

	// Update section loading state
	useEffect(() => {
		updateSectionState(isLoading, "chart");
	}, [isLoading, updateSectionState]);

	return {
		chartData: data,
		isLoading,
		isError,
		error
	};
}
